import { render, staticRenderFns } from "./Resource.vue?vue&type=template&id=1b0faafb&scoped=true"
import script from "./Resource.vue?vue&type=script&lang=js"
export * from "./Resource.vue?vue&type=script&lang=js"
import style0 from "./Resource.vue?vue&type=style&index=0&id=1b0faafb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0faafb",
  null
  
)

export default component.exports